export class RowResult {
    id: number;
    data: any[];
}
